import Vue from 'vue'
import Router from 'vue-router'
import {Toast} from 'vant'
import {loading} from '@/common/loading';

Vue.use(Router)

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRoutes = [
    {
        path: '/',
        name: 'index',
        component: () => import('../views/index/index.vue'),
        meta: {
            title: '首页',
            // keepAlive: true  //需要被缓存，页面不刷新
        }
    },
    {
        path: '/jiagecaiji',
        name: 'jiagecaiji',
        component: () => import('../views/jiagecaiji/jiagecaiji.vue'),
        meta: {
            title: '价格采集tb',
        }
    },
    {
        path: '/caijixiangqing',
        name: 'caijixiangqing',
        component: () => import('../views/jiagecaiji/component/caijixiangqing.vue'),
        meta: {
            title: '价格采集详情tb',
        }
    },
    {
        path: '/daibanList',
        name: 'daibanList',
        component: () => import('../views/index/component/daibanList.vue'),
        meta: {
            title: '待办列表',
        }
    },
    {
        path: '/jiagecaijiNew',
        name: 'jiagecaijiNew',
        component: () => import('../views/jiagecaijiNew/jiagecaijiNew.vue'),
        meta: {
            title: '价格采集',
        }
    },
    {
        path: '/caijixiangqingNew',
        name: 'caijixiangqingNew',
        component: () => import('../views/jiagecaijiNew/component/caijixiangqingNew.vue'),
        meta: {
            title: '价格采集详情',
        }
    },
    {
        path: '/caijixiangqingLessNew',
        name: 'caijixiangqingLessNew',
        component: () => import('../views/jiagecaijiNew/component/caijixiangqingLessNew.vue'),
        meta: {
            title: '价格采集详情',
        }
    },
    {
        path: '/agentFill',
        name: 'agentFill',
        component: () => import('../views/agentFill/agentFill.vue'),
        meta: {
            title: '市级代填报',
        }
    },
    {
        path: '/tianbaoxiangqing',
        name: 'tianbaoxiangqing',
        component: () => import('../views/agentFill/component/tianbaoxiangqing.vue'),
        meta: {
            title: '市级代填报详情',
        }
    },
    {
        path: '/tianbaoxiangqingLess',
        name: 'tianbaoxiangqingLess',
        component: () => import('../views/agentFill/component/tianbaoxiangqingLess.vue'),
        meta: {
            title: '市级代填报详情',
        }
    },
    {
        path: '/jiageshenheListNew',
        name: 'jiageshenheListNew',
        component: () => import('../views/jiageshenheListNew/jiageshenheListNew.vue'),
        meta: {
            title: '价格审核',
        }
    },
    {
        path: '/jiageshenheNew',
        name: 'jiageshenheNew',
        component: () => import('../views/jiageshenheListNew/component/jiageshenheNew.vue'),
        meta: {
            title: '价格审核详情',
        }
    },
    {
        path: '/jiageshenheLessNew',
        name: 'jiageshenheLessNew',
        component: () => import('../views/jiageshenheListNew/component/jiageshenheLessNew.vue'),
        meta: {
            title: '价格审核详情',
        }
    },
    // {
    //     path: '/xiaoxitixing',
    //     name: 'xiaoxitixing',
    //     component: () => import('../views/xiaoxitixing/xiaoxitixing.vue'),
    //     meta: {
    //         title: '消息提醒',
    //     }
    // },
    {
        path: '/warningQuery',
        name: 'warningQuery',
        component: () => import('../views/warningQuery/warningQuery.vue'),
        meta: {
            title: '预警查询',
        }
    },
    {
        path: '/provincialWarningManage',
        name: 'provincialWarningManage',
        component: () => import('../views/provincialWarningManage/provincialWarningManage.vue'),
        meta: {
            title: '省级预警信息处理',
        }
    },
    {
        path: '/tongzhigonggao',
        name: 'tongzhigonggao',
        component: () => import('../views/tongzhigonggao/tongzhigonggao.vue'),
        meta: {
            title: '通知公告',
        }
    },
    {
        path: '/tongzhixiangqing',
        name: 'tongzhixiangqing',
        component: () => import('../views/tongzhigonggao/component/tongzhixiangqing.vue'),
        meta: {
            title: '通知详情',
        }
    },
    {
        path: '/addressBook',
        name: 'addressBook',
        component: () => import('../views/addressBook/addressBook.vue'),
        meta: {
            title: '通讯录',
            // keepAlive: true
        }
    },
    {
        path: '/loginOld2',
        name: 'loginOld2',
        component: () => import('../views/loginOld2/loginOld2.vue'),
        meta: {
            title: '登录页面',
            // keepAlive: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/login.vue'),
        meta: {
            title: '登录页面',
            // keepAlive: true
        }
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('../views/error/error.vue'),
        meta: {
            title: '错误',
            // keepAlive: true
        }
    },
    {
        path: '/userInfo',
        name: 'userInfo',
        component: () => import('../views/userInfo/userInfo.vue'),
        meta: {
            title: '账号信息',
            // keepAlive: true
        }
    },
    {
        path: '/perInfoManage',
        name: 'perInfoManage',
        component: () => import('../views/perInfoManage/perInfoManage.vue'),
        meta: {
            title: '个人中心',
            // keepAlive: true
        }
    },
    {
        path: '/marketInspection',
        name: 'marketInspection',
        component: () => import('../views/marketInspection/marketInspection.vue'),
        meta: {
          title: '市场巡查',
          // keepAlive: true
        },
      },
      {
        path: '/marketInspectionModify',
        name: 'marketInspectionModify',
        component: () => import('../views/marketInspection/modify.vue'),
        meta: {
          title: '市场巡查-操作',
          // keepAlive: true
        },
      }
    // {
    //     path: '/publishList',
    //     name: 'publishList',
    //     component: () => import('../views/index/component/publishList.vue'),
    //     meta: {
    //         title: '价格发布',
    //         // keepAlive: true
    //     }
    // },
]
//异步挂载的路由
//动态需要根据权限加载的路由表
export const asyncRoutes = [
    {path: '*', redirect: '/404', hidden: true}
]

const createRouter = () => new Router({
    mode: 'hash', // require service support
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})
const router = createRouter()

// 路由前置导航守卫
router.beforeEach((to, from, next) => {
    // 根据路由元信息设置文档标题
    window.document.title = to.meta.title
    next()
   /* const role=localStorage.getItem("ifShowleaderCheck");
    const ifTrue=to.meta.roleCheck==role;

    console.log(role)
    console.log(to.meta.roleCheck)
    console.log(ifTrue)

    if (ifTrue==true && to.meta.roleCheck!=undefined) {
       /!* this.$dialog.alert({
            message: '该用户无此功能权限!'
        })*!/
        //Toast( '当前用户无此功能权限!');
        this.$dialog.alert({
            message: '当前用户无此功能权限!'
        })
        loading(false)
        return;
    } else {
        next()
    }*/
})

export default router
